'use strict';

wbApp.config(['$routeProvider',
  function ($routeProvider) {
      $routeProvider.
        when('/dashboard', {
            templateUrl: 'dashboard/dashboard.html',
            controller: 'DashboardCtrl',
            label: 'TXT_MENU_DASHBOARD'
        })
        .when('/preview-hours/state-codes', {
            templateUrl: 'preview-hours/state-codes.html',
            controller: 'StateCodesCtrl',
            label: 'TXT_MENU_PREVIEW_HOURS_STATE_CODES'
        })
        .when('/preview-hours/preview-hours', {
            templateUrl: 'preview-hours/preview-hours.html',
            controller: 'PreviewHoursCtrl',
            label: 'TXT_MENU_PREVIEW_HOURS_PREVIEW_HOURS'
        })
        .when('/preview-hours/preview-interest', {
            templateUrl: 'preview-hours/preview-interest.html',
            controller: 'PreviewInterestCtrl',
            label: 'TXT_MENU_PREVIEW_HOURS_PREVIEW_INTEREST'
        })
        .when('/reservations/domains', {
            templateUrl: 'reservations/domains.html',
            controller: 'DomainsCtrl',
            label: 'TXT_MENU_RESERVATIONS_DOMAINS'
        })
        .when('/reservations/schedule', {
            templateUrl: 'reservations/reservations-schedule.html',
            controller: 'ReservationSchedulesCtrl',
            label: 'TXT_MENU_RESERVATIONS_RESERVATIONS_SCHEDULE'
        })
        .when('/rents/item-types', {
            templateUrl: 'rents/item-type/item-type.html',
            controller: 'ItemTypesCtrl',
            label: 'TXT_MENU_RENTS_ITEM_TYPES'
        })
        .when('/rents/rent-category-groups', {
            templateUrl: 'rents/rent-category-group/rent-category-group.html',
            controller: 'RentCategoryGroupsCtrl',
            label: 'TXT_MENU_RENTS_RENT_CATEGORY_GROUPS'
        })
        .when('/rents/rent-categories', {
            templateUrl: 'rents/rent-category/rent-category.html',
            controller: 'RentCategoriesCtrl',
            label: 'TXT_MENU_RENTS_RENT_CATEGORIES'
        })
        .when('/rents/rent-items', {
            templateUrl: 'rents/rent-item/rent-item.html',
            controller: 'RentItemsCtrl',
            label: 'TXT_MENU_RENTS_RENT_ITEMS'
        })
        .when('/rents/rents', {
            templateUrl: 'rents/rent/rent.html',
            controller: 'RentsCtrl',
            label: 'TXT_MENU_RENTS_RENTS'
        })
        .when('/crm/forms', {
            templateUrl: 'forms/forms.html',
            controller: 'FormsCtrl',
            label: 'TXT_MENU_CRM_FORMS'
        })
        .when('/crm/leads', {
            templateUrl: 'leads/leads.html',
            controller: 'LeadsCtrl',
            label: 'TXT_MENU_CRM_LEADS'
        })
        .when('/crm/levels', {
            templateUrl: 'levels/levels.html',
            controller: 'LevelsCtrl',
            label: 'TXT_MENU_CRM_LEVELS'
        })
        .when('/crm/phases', {
            templateUrl: 'phases/phases.html',
            controller: 'PhasesCtrl',
            label: 'TXT_MENU_CRM_PHASES'
        })
        .when('/users/users', {
            templateUrl: 'users/users.html',
            controller: 'UsersCtrl',
            label: 'TXT_MENU_USERS'
        })
        .when('/users/user-roles', {
            templateUrl: 'users/user-roles.html',
            controller: 'UserRolesCtrl',
            label: 'TXT_MENU_USERS_USER_ROLES'
        })
        .when('/users/reference-source', {
            templateUrl: 'users/reference-source.html',
            controller: 'ReferenceSourceCtrl',
            label: 'TXT_MENU_USERS_REFERENCE_SOURCE'
        })
        .when('/users/employees', {
            templateUrl: 'users/employees/employees.html',
            controller: 'EmployeesCtrl',
            label: 'TXT_MENU_USERS_EMPLOYEES'
        })
        .when('/users/students', {
            templateUrl: 'users/students/students.html',
            controller: 'StudentsCtrl',
            label: 'TXT_MENU_USERS_STUDENTS'
        })
        .when('/users/users-consents', {
            templateUrl: 'users/users-consents/users-consents.html',
            controller: 'UsersConsentsCtrl',
            label: 'TXT_MENU_USERS_USERS_CONSENTS'
        })
        .when('/promo/membership', {
            templateUrl: 'promo/membership.html',
            controller: 'MembershipCtrl',
            label: 'TXT_MENU_PROMO_MEMBERSHIP'
        })
        .when('/activities/activities', {
            templateUrl: 'activities/activities.html',
            controller: 'ActivitiesCtrl',
            label: 'TXT_MENU_ACTIVITIES_ACTIVITIES'
        })
        .when('/activities/activity-schedules', {
            templateUrl: 'activities/activity-schedule.html',
            controller: 'ActivitySchedulesCtrl',
            label: 'TXT_MENU_ACTIVITIES_ACTIVITY_SCHEDULES'
        })
        .when('/activities/activity-reconciliation', {
            templateUrl: 'activities/activity-reconciliation.html',
            controller: 'ActivityReconciliationCtrl',
            label: 'TXT_MENU_ACTIVITIES_ACTIVITY_RECONCILIATION'
        })
        .when('/activities/activity-tariffs', {
            templateUrl: 'activities/activity-tariffs/activity-tariffs.html',
            controller: 'ActivityTariffCtrl',
            label: 'TXT_MENU_ACTIVITIES_ACTIVITY_TARIFFS'
        })
        .when('/activities/cz-ms-mt-registry', {
            templateUrl: 'cz-ms-mt-registry/cz-ms-mt-registry.html',
            controller: 'CzMsMtRegistryCtrl',
            label: 'TXT_MENU_ACTIVITIES_CZ_MS_MT_REGISTRY'
        })          
        .when('/activities/contracts', {
            templateUrl: 'activities/contracts/contract.html',
            controller: 'ContractsCtrl',
            label: 'TXT_MENU_ACTIVITIES_CONTRACTS'
        })
        .when('/activities/contract-templates', {
            templateUrl: 'activities/contract-templates/contract-template.html',
            controller: 'ContractTemplatesCtrl',
            label: 'TXT_MENU_ACTIVITIES_CONTRACT_TEMPLATES'
        })
        .when('/messages/email', {
          templateUrl: 'messages/email.html',
          controller: 'EmailCtrl',
          label: 'TXT_MENU_MESSAGES_EMAIL'
        })
        .when('/messages/sent-emails', {
            templateUrl: 'messages/sent-emails.html',
            controller: 'SentEmailsCtrl',
            label: 'TXT_MENU_SENT_EMAILS'
        })
        .when('/messages/email-templates', {
            templateUrl: 'messages/email-templates.html',
            controller: 'EmailTemplatesCtrl',
            label: 'TXT_MENU_MESSAGES_EMAIL_TEMPLATES'
        })
        .when('/messages/sms', {
            templateUrl: 'messages/sms.html',
            controller: 'SmsCtrl',
            label: 'TXT_MENU_MESSAGES_SMS'
        })
        .when('/courses/subjects', {
            templateUrl: 'courses/subjects.html',
            controller: 'SubjectsCtrl',
            label: 'TXT_MENU_COURSES_SUBJECTS'
        })
        .when('/courses/courses', {
            templateUrl: 'courses/courses/courses.html',
            controller: 'CoursesCtrl',
            label: 'TXT_MENU_COURSES_COURSES'
        })
        .when('/courses/online-meetings', {
            templateUrl: 'courses/online-meetings/online-meetings.html',
            controller: 'OnlineMeetingsCtrl',
            label: 'TXT_MENU_COURSES_ONLINE_MEETINGS'
        })
        .when('/finance/payments', {
            templateUrl: 'finance/payments/payments.html',
            controller: 'PaymentsCtrl',
            label: 'TXT_MENU_FINANCE_PAYMENTS'
        })
        .when('/finance/due-payments', {
            templateUrl: 'finance/due-payments/due-payments.html',
            controller: 'DuePaymentsCtrl',
            label: 'TXT_MENU_FINANCE_DUE_PAYMENTS'
        })
        .when('/finance/invoices', {
            templateUrl: 'finance/invoices/invoices.html',
            controller: 'InvoicesCtrl',
            label: 'TXT_MENU_FINANCE_INVOICES'
        })
        .when('/finance/bank', {
            templateUrl: 'finance/bank/bank.html',
            controller: 'BankCtrl',
            label: 'TXT_MENU_FINANCE_BANK'
        })
        .when('/finance/accounting-books', {
            templateUrl: 'finance/accounting-books/accounting-books.html',
            controller: 'AccountingBookCtrl',
            label: 'TXT_MENU_FINANCE_ACCOUNTING_BOOKS'
        })
        .when('/finance/accounting-books/:id', {
            templateUrl: 'finance/accounting-books/accounting-books.html',
            controller: 'AccountingBookCtrl',
           // label: 'TXT_MENU_FINANCE_ACCOUNTING_BOOKS'
        })          
        .when('/finance/accounting-books/:id/tab/:tabId', {
            templateUrl: 'finance/accounting-books/accounting-books.html',
            controller: 'AccountingBookCtrl',
         //   label: 'TXT_MENU_FINANCE_ACCOUNTING_BOOKS'
        })
        .when('/finance/compensations', {
            templateUrl: 'finance/compensations/compensations.html',
            controller: 'CompensationsCtrl',
            label: 'TXT_MENU_FINANCE_COMPENSATIONS'
        })
        .when('/finance/online-payment-configurations', {
            templateUrl: 'finance/online-payment-configurations/online-payment-configurations.html',
            controller: 'OnlinePaymentConfigurationCtrl',
            label: 'TXT_MENU_FINANCE_ONLINE_PAYMENT_CONFIGURATION'
        })
        .when('/finance/online-payments', {
            templateUrl: 'finance/online-payments/online-payments.html',
            controller: 'OnlinePaymentsCtrl',
            label: 'TXT_MENU_FINANCE_ONLINE_PAYMENTS'
        })
        .when('/finance/tax-documents', {
            templateUrl: 'finance/tax-documents/tax-documents.html',
            controller: 'TaxDocumentsCtrl',
            label: 'TXT_MENU_FINANCE_TAX_DOCUMENTS'
        })
        .when('/storage/protected-storage', {
            templateUrl: 'storage/protected-storage/protected-storage.html',
            controller: 'ProtectedStorageCtrl',
            label: 'TXT_MENU_STORAGE_PROTECTED_STORAGE'
        })
        .when('/storage/pictures', {
            templateUrl: 'storage/pictures/pictures.html',
            controller: 'PicturesCtrl',
            label: 'TXT_MENU_STORAGE_PICTURES'
        })
        .when('/survey/surveys', {
            templateUrl: 'survey/surveys.html',
            controller: 'SurveysCtrl',
            label: 'TXT_MENU_SURVEYS_SURVEY'
        })
        .when('/reports/registeredAttendance', {
            templateUrl: 'reports/registered-attendance.html',
            controller: 'RegisteredAttendanceCtrl',
            label: 'TXT_MENU_DASHBOARD_REGISTERED_ATTENDANCE'
        })
        .when('/reports/franchise-attendance-summary', {
            templateUrl: 'reports/franchise-attendance-summary.html',
            controller: 'FranchiseAttendanceSummaryCtrl',
            label: 'TXT_MENU_REPORTS_FRANCHISE_ATTENDANCE_SUMMARY'
        })
        .when('/reports/registrations-summary', {
            templateUrl: 'reports/registrations-summary.html',
            controller: 'RegistrationsSummaryCtrl',
            label: 'TXT_MENU_REPORTS_REGISTRATIONS_SUMMARY'
        })
        .when('/reports/one-offs-summary', {
            templateUrl: 'reports/one-offs-summary.html',
            controller: 'OneOffsSummaryCtrl',
            label: 'TXT_MENU_REPORTS_ONE_OFFS_SUMMARY'
        })
        .when('/reports/course-student-fluctuation', {
            templateUrl: 'reports/course-student-fluctuation.html',
            controller: 'CourseStudentFluctuationCtrl',
            label: 'TXT_MENU_REPORTS_COURSE_STUDENT_FLUCTUATION'
        })
        .when('/reports/courses-attendance-summary', {
            templateUrl: 'reports/courses-attendance-summary.html',
            controller: 'CoursesAttendanceSummaryCtrl',
            label: 'TXT_MENU_REPORTS_COURSES_ATTENDANCE_SUMMARY'
        })
        .when('/setting/semesters', {
            templateUrl: 'setting/semesters/semesters.html',
            controller: 'SemestersCtrl',
            label: 'TXT_MENU_SETTING_SEMESTERS'
        })
        .when('/setting/classrooms', {
            templateUrl: 'setting/classrooms/classrooms.html',
            controller: 'ClassroomsCtrl',
            label: 'TXT_MENU_SETTING_CLASSROOMS'
        })
        .when('/setting/courseTypes', {
            templateUrl: 'setting/course-types/course-types.html',
            controller: 'CourseTypesCtrl',
            label: 'TXT_MENU_SETTING_COURSE_TYPES'
        })
        .when('/setting/compensation-groups', {
            templateUrl: 'setting/compensation-groups/compensation-groups.html',
            controller: 'CompensationGroupsCtrl',
            label: 'TXT_MENU_SETTING_COMPENSATION_GROUPS'
        })
        .when('/users/groups', {
            templateUrl: 'users/groups/groups.html',
            controller: 'GroupsCtrl',
            label: 'TXT_MENU_SETTING_GROUPS'
        })
        .when('/setting/age-ranges', {
            templateUrl: 'setting/age-ranges/age-ranges.html',
            controller: 'AgeRangesCtrl',
            label: 'TXT_MENU_SETTING_AGE_RANGES'
        })
        .when('/setting/holiday-calendars', {
            templateUrl: 'setting/holiday-calendars/holiday-calendars.html',
            controller: 'HolidayCalendarsCtrl',
            label: 'TXT_MENU_SETTING_HOLIDAY_CALENDARS'
        })
        .when('/setting/terminals', {
            templateUrl: 'setting/terminals/terminals.html',
            controller: 'TerminalsCtrl',
            label: 'TXT_MENU_SETTING_TERMINALS'
        })
          .when('/setting/news', {
              templateUrl: 'setting/news/news.html',
              controller: 'NewsCtrl',
              label: 'TXT_MENU_SETTING_NEWS'
          })          
        .when('/franchise/franchises', {
            templateUrl: 'franchise/franchises/franchises.html',
            controller: 'FranchisesCtrl',
            label: 'TXT_MENU_FRANCHISE_FRANCHISES'
        })
        .when('/franchise/franchises-attendance-summary', {
            templateUrl: 'franchise/franchises/franchises-attendance-summary.html',
            controller: 'FranchisesAttendanceSummaryCtrl',
            label: 'TXT_MENU_FRANCHISE_FRANCHISES_ATTENDANCE_SUMMARY'
        })
        .when('/rfid-cards/rfid-card-log', {
            templateUrl: 'rfid-cards/attendance-log/attendance-log.html',
            controller: 'AttendanceLogCtrl',
            label: 'TXT_MENU_RFID_CARD_LOG_RFID_CARD_LOG'
        })
        .when('/rfid-cards/rfid-card-log-upload-contact', {
            templateUrl: 'rfid-cards/log-upload-contact/log-upload-contact.html',
            controller: 'LogUploadContactCtrl',
            label: 'TXT_MENU_RFID_CARD_LOG_RFID_CARD_LOG_UPLOAD_CONTACT'
        })
        .when('/rfid-cards/device-registration', {
            templateUrl: 'rfid-cards/device-registration/device-registration.html',
            controller: 'DeviceRegistrationCtrl',
            label: 'TXT_MENU_RFID_CARD_LOG_TXT_MENU_RFID_CARD_LOG_DEVICE_REGISTRATION'
        })
        .when('/system/settings', {
            templateUrl: 'system/settings/settings.html',
            controller: 'SettingsCtrl',
            label: 'TXT_MENU_SYSTEM_SETTINGS'
        })
        .when('/system/sms-history', {
            templateUrl: 'system/sms-history/sms-history.html',
            controller: 'SmsHistoryCtrl',
            label: 'TXT_MENU_SYSTEM_SMS_HISTORY'
        })
        .when('/system/data-export-history', {
            templateUrl: 'system/data-export-history/data-export-history.html',
            controller: 'DataExportHistoryCtrl',
            label: 'TXT_MENU_SYSTEM_DATA_EXPORT_HISTORY'
        })
        .when('/actions/action-categories', {
            templateUrl: 'actions/action-categories.html',
            controller: 'ActionCategoriesCtrl',
            label: 'TXT_MENU_ACTIONS_ACTION_CATEGORIES'
        })
        .when('/actions/actions', {
            templateUrl: 'actions/actions/actions.html',
            controller: 'ActionsCtrl',
            label: 'TXT_MENU_ACTIONS_ACTIONS'
        })
        .when('/schedule/schedule', {
            templateUrl: 'schedule/schedule.html',
            controller: 'ScheduleCtrl',
            label: 'TXT_MENU_SCHEDULE_SCHEDULE'
        })
        .otherwise({
            redirectTo: '/dashboard'
        });
  }]);

